<template>
  <div class="sqle">
    <div class="sqle-warn">
      <strong>Atencao:</strong>
      o SQL informado e executado diretamente na conexao escolhida. Apenas comandos de leitura
      (<code>SELECT</code>/<code>WITH</code>) sao aceitos pelo backend, com <em>statement_timeout</em>
      e <em>READ ONLY</em>. Use <code>:variavel</code> para parametros do payload.
    </div>
    <codemirror v-model="codigo" :options="options" @input="onInput" />
    <div class="sqle-vars" v-if="vars.length">
      <span class="sqle-vars__label">Variáveis detectadas:</span>
      <span v-for="v in vars" :key="v" class="sqle-vars__tag">{{ v }}</span>
    </div>
    <div class="sqle-vars sqle-vars--avail" v-if="availableFields.length">
      <span class="sqle-vars__label">Disponíveis:</span>
      <button
        v-for="f in availableFields"
        :key="f.name"
        type="button"
        class="sqle-vars__chip"
        @click="insertVar(f.name)"
        :title="`Inserir :${f.name}`"
      >:{{ f.name }}</button>
    </div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';
import 'codemirror/addon/selection/active-line.js';
import 'codemirror/addon/display/autorefresh.js';
import 'codemirror/mode/sql/sql.js';

const REGEX_VARS = /(?<!:)(:[a-zA-Z_][a-zA-Z0-9_]*)/g;

export default {
  name: 'AcaoObjetoSqlEditor',
  components: { codemirror },
  props: {
    value: { type: String, default: '' },
    fields: { type: Array, default: () => [] },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return { codigo: this.value || '' };
  },
  computed: {
    availableFields() { return this.fields || []; },
    vars() {
      return [...new Set((this.codigo || '').match(REGEX_VARS) || [])];
    },
    options() {
      return {
        tabSize: 2,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-sql',
        autoRefresh: true,
        lineWrapping: true,
        readOnly: this.readonly,
        theme: 'monokai',
      };
    },
  },
  watch: {
    value(v) { if (v !== this.codigo) this.codigo = v || ''; },
  },
  methods: {
    onInput(v) { this.$emit('input', v); },
    insertVar(name) {
      const token = `:${name}`;
      const next  = (this.codigo || '') + (this.codigo && !this.codigo.endsWith(' ') ? ' ' : '') + token;
      this.codigo = next;
      this.$emit('input', next);
    },
  },
};
</script>

<style scoped>
.sqle { width: 100%; }
.sqle-warn {
  background: #fff8e1;
  border: 1px solid #ffe082;
  color: #6b4f00;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.5;
  margin-bottom: 8px;
}
.sqle-warn code {
  background: #fff3cc;
  padding: 1px 4px;
  border-radius: 3px;
  font-size: 11px;
}
.sqle ::v-deep .CodeMirror {
  height: 240px;
  border-radius: 8px;
  font-size: 12px;
  font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
}
.sqle-vars {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 11px;
  color: #667085;
}
.sqle-vars__label { font-weight: 600; text-transform: uppercase; letter-spacing: 0.4px; font-size: 10px; }
.sqle-vars__tag {
  background: #fef6e6;
  color: #b85f00;
  border: 1px solid #fce4b3;
  padding: 2px 7px;
  border-radius: 4px;
  font-family: 'Menlo', 'Monaco', monospace;
  font-size: 11px;
  font-weight: 600;
}
.sqle-vars--avail .sqle-vars__chip {
  background: #f2f2f8;
  color: #3a3e81;
  border: 1px solid #dddce9;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: 'Menlo', 'Monaco', monospace;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}
.sqle-vars--avail .sqle-vars__chip:hover { background: #3a3e81; color: #fff; border-color: #3a3e81; }
</style>
